export default __webpack_public_path__ + "static/article-hosting-christmas-lunch-e0d859f4a94e84c7a20d1b6b0b220084.jpg";